import { render, staticRenderFns } from "./ProgramCard.vue?vue&type=template&id=20347caa&scoped=true"
import script from "./ProgramCard.vue?vue&type=script&lang=ts"
export * from "./ProgramCard.vue?vue&type=script&lang=ts"
import style0 from "./ProgramCard.vue?vue&type=style&index=0&id=20347caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20347caa",
  null
  
)

export default component.exports